import gql from 'graphql-tag';

/**
 * get a list of users who can be added to a channel
 */
export const GET_CHANNEL_MESSAGEABLE_USERS = gql`
  query($centerId: String!) {
    getChannelMessageableUsers(centerId: $centerId) {
      id
      name
      avatar
    }
  }
`;

/**
 * get channels the requester belongs to
 */
export const GET_CHANNELS = gql`
  query {
    getChannels {
      id
      name
      topic
      private
      directMessage
      createdAt
      createdById
      lastMessageSentAt
      mostRecentMessage {
        message
        createdAt
      }
      memberIds
      broadcastType
      broadcastTypeId
      unreadMessageCount
    }
  }
`;

/**
 * get messages for a channel since a certain time
 */
export const GET_CHANNEL_MESSAGES = gql`
  query($channelId: String!, $datetime: String!) {
    getChannelMessagesSince(channelId: $channelId, datetime: $datetime) {
      id
      senderId
      message
      createdAt
      user {
        id
        name
        avatar
      }
      attachment {
        url
        key
        type
      }
    }
  }
`;

/**
 * get a list of employees the requester can direct message
 */
export const GET_DIRECT_MESSAGEABLE_EMPLOYEES = gql`
  query($centerId: String!) {
    getChannelMessageableUsers(centerId: $centerId) {
      id
      name
      avatar
    }
  }
`;

/**
 * get a list of public channels at a center
 */
export const GET_PUBLIC_CHANNELS_AT_CENTER = gql`
  query($centerId: String!) {
    getPublicChannels(centerId: $centerId) {
      id
      name
      topic
      lastMessageSentAt
    }
  }
`;

export const GET_CHANNEL_MEMBERS = gql`
  query($channelId: String!) {
    getChannelMembers(channelId: $channelId) {
      id
      name
      avatar
    }
  }
`;

export const GET_DIRECT_MESSAGEABLE_PARENTS = gql`
  query($centerId: String!) {
    getDirectMessageableParentsAsEmployee(centerId: $centerId) {
      id
      name
    }
  }
`;

export const GET_MANAGER_MESSAGES_OVERVIEW = gql`
  query($query: MessagesQueryDetails!) {
    getAllMessagesAsManager(query: $query) {
      messages {
        id
        channelId
        senderId
        message
        createdAt
        user {
          id
          name
        }
        channel {
          name
          directMessage
          private
          broadcastType
        }
      }
      nextToken
    }
  }
`;

export const GET_ALL_CHANNELS_AT_CENTER_AS_MANAGER = gql`
  query($centerId: String!) {
    getAllChannelsAtCenterAsManager(centerId: $centerId) {
      id
      name
      private
      directMessage
    }
  }
`;
